import React from 'react';
import { Box, Container, Typography } from '@mui/material';

const HowKoinAppWorks = () => {
  const steps = [
    {
      title: 'Download the app',
      description: 'Get KOIN on your Android phone from the Play Store.'
    },
    {
      title: 'Pick a campaign',
      description: 'Browse brand campaigns and complete the steps listed on each one.'
    },
    {
      title: 'Get verified',
      description: 'Your reward is added once the brand verifies the task.'
    },
    {
      title: 'Withdraw to UPI',
      description: 'Send verified rewards to your UPI ID. Processing takes 24–72 hours.'
    }
  ];

  return (
    <Box
      id="how-it-works"
      component="section"
      sx={{
        width: '100%',
        pt: { xs: 5, md: 6 },
        pb: 0,
        background: 'linear-gradient(180deg, #F57C00 0%, #E65100 100%)',
        scrollMarginTop: '80px'
      }}
    >
      <Container maxWidth="lg">
        <Box sx={{ textAlign: 'center', mb: { xs: 4, md: 6 } }}>
          <Typography
            component="h2"
            sx={{
              fontSize: { xs: '2rem', sm: '2.5rem', md: '2.9rem' },
              fontWeight: 700,
              letterSpacing: '-0.02em',
              color: '#FFFFFF',
              fontFamily: 'General-Sans-bold, sans-serif',
              mb: 1.25
            }}
          >
            How KOIN works
          </Typography>
          <Typography sx={{ fontSize: '1.2rem', fontWeight: 600, color: '#FFFFFF', maxWidth: '520px', mx: 'auto' }}>
            Four steps from download to your first withdrawal.
          </Typography>
        </Box>

        <Box
          component="ol"
          sx={{
            listStyle: 'none',
            m: 0,
            p: { xs: 3, md: 1.5 },
            background: '#FFFFFF',
            borderRadius: { xs: '24px', md: '32px' },
            boxShadow: '0 30px 60px -24px rgba(143, 50, 0, 0.45)',
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', md: 'repeat(4, 1fr)' }
          }}
        >
          {steps.map((step, index) => (
            <Box
              component="li"
              key={step.title}
              sx={{
                position: 'relative',
                display: 'flex',
                flexDirection: { xs: 'row', md: 'column' },
                gap: { xs: 2, md: 2.5 },
                p: { xs: 0, md: 3.5 },
                pb: { xs: index === steps.length - 1 ? 0 : 4, md: 3.5 },
                // hairline divider between columns on desktop
                borderLeft: { md: index === 0 ? 'none' : '1px solid #F3E6CF' },
                // timeline line between steps on mobile
                '&:not(:last-of-type)::after': {
                  content: '""',
                  display: { xs: 'block', md: 'none' },
                  position: 'absolute',
                  left: 23,
                  top: 54,
                  bottom: 6,
                  width: 2,
                  borderRadius: 1,
                  background: '#FFE3B0'
                }
              }}
            >
              <Box
                sx={{
                  flexShrink: 0,
                  width: 48,
                  height: 48,
                  borderRadius: '50%',
                  display: 'grid',
                  placeItems: 'center',
                  color: '#FFF',
                  fontWeight: 700,
                  fontSize: '1.15rem',
                  fontFamily: 'General-Sans-bold, sans-serif',
                  background: 'linear-gradient(135deg, #FFB300 0%, #F57C00 100%)',
                  boxShadow: 'inset 0 0 0 4px #FFD98A'
                }}
              >
                {index + 1}
              </Box>
              <Box>
                <Typography
                  component="h3"
                  sx={{ fontSize: '1.15rem', fontWeight: 700, color: '#1F2937', mb: 0.75, fontFamily: 'General-Sans-bold, sans-serif' }}
                >
                  {step.title}
                </Typography>
                <Typography sx={{ fontSize: '0.98rem', color: '#4B5563', lineHeight: 1.55 }}>
                  {step.description}
                </Typography>
              </Box>
            </Box>
          ))}
        </Box>
      </Container>
      {/* Curve back to white, mirroring the hero's wave */}
      <Box
        component="svg"
        aria-hidden
        viewBox="0 0 1440 140"
        preserveAspectRatio="none"
        sx={{ display: 'block', width: '100%', height: { xs: 56, md: 110 }, mt: { xs: 7, md: 10 }, mb: '-1px' }}
      >
        <path d="M0 140 Q720 -10 1440 140 Z" fill="#FFFFFF" />
      </Box>
    </Box>
  );
};

export default HowKoinAppWorks;
